import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 *
 */
class ReportServices {
  /**
   * @param {*} orgId
   * @param {*} tenantIds
   * @param {*} fromDate
   * @param {*} toDate
   * @param firstSubUrl
   * @param secondSubUrl
   * @param type
   * @param {*} reportName
   * @return
   */

  getReports = async (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, page, limit, departmentId, moType, status, sellerId, costingMethod, customerId, category) => {
    let url = `${Constants.GET_REPORTS}/`;
    if (secondSubUrl) {
      if (firstSubUrl) url += `${firstSubUrl}/`;
      if (secondSubUrl) url += `${secondSubUrl}?`;
      if (orgId) url += `org_id=${orgId}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (fromDate) url += `from_date=${fromDate}&`;
      if (toDate) url += `to_date=${toDate}&`;
      if (page) url += `page=${page}&`;
      if (limit) url += `limit=${limit}&`;
      if (departmentId) url += `department_id=${departmentId}&`;
      if (costingMethod) url += `costing_method=${costingMethod}&`;
      if (moType) url += `mo_type=${moType}&`;
      if (status) url += `mo_type=${status}&`;
      if (sellerId) url += `seller_ids=${sellerId}&`;
      if (customerId) url += `customer_ids=${customerId}&`;
      if (category) url += `product_category_ids=${category}&`;
    } else {
      if (firstSubUrl) url += `${firstSubUrl}?`;
      if (orgId) url += `org_id=${orgId}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (fromDate) url += `from_date=${fromDate}&`;
      if (toDate) url += `to_date=${toDate}&`;
      if (page) url += `page=${page}&`;
      if (limit) url += `limit=${limit}&`;
      if (departmentId) url += `department_id=${departmentId}&`;
      if (costingMethod) url += `costing_method=${costingMethod}&`;
      if (moType) url += `mo_type=${moType}&`;
      if (status) url += `status=${status}&`;
      if (sellerId) url += `seller_ids=${sellerId}`;
      if (customerId) url += `customer_ids=${customerId}`;
      if (category) url += `product_category_ids=${category}&`;
    }
    const reports = await Helpers.get({
      url,
    });

    return reports;
  }

  /**
 * @return
 * @param page
 * @param orgId
 * @param tenantId
 * @param limit
 */
  getProductionReports = async (tenantIds, fromDate, toDate, page, limit, departmentId, moType, status, category) => {
    let url = `${Constants.GET_PRODUCTION_REPORTS}?`;
    if (tenantIds) url += `tenant_ids=${tenantIds}&`;
    if (fromDate) url += `from_date=${fromDate}&`;
    if (toDate) url += `to_date=${toDate}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (moType) url += `mo_type=${moType}&`;
    if (status) url += `status=${status}&`;
    if (category) url += `product_category_ids=${category}&`;
    const users = Helpers.get({ url });
    return users;
  }

  /**
* @return
* @param page
* @param orgId
* @param tenantId
* @param limit
*/
  getStockAgeingReports = async (tenantIds, method, interval, steps, date, departmentId, currentPage, limit, category) => {
    let url = `${Constants.GET_REPORTS}/stock_ageing_report?`;
    if (tenantIds) url += `tenant_ids=${tenantIds}&`;
    if (method) url += `method=${method}&`;
    if (interval) url += `interval=${interval}&`;
    if (steps) url += `steps=${steps}&`;
    if (date) url += `date=${date}&`;
    if (currentPage) url += `page=${currentPage}&`;
    if (limit) url += `limit=${limit}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (category) url += `product_category_ids=${category}&`;

    const reports = Helpers.get({ url });
    return reports;
  }

  /**
   * @param {*} firstSubUrl
   * @param {*} secondSubUrl
   * @param {*} orgId
   * @param {*} tenantIds
   * @param {*} fromDate
   * @param {*} toDate
   * @param fileReportType
   * @param reportName
   * @param {*} type
   * @param {*} sellerId
   * @return
   */
  getReportsDownload = async (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category) => {
    let url = `${Constants.GET_REPORTS}/`;
    if (secondSubUrl) {
      if (firstSubUrl) url += `${firstSubUrl}/`;
      if (secondSubUrl) url += `${secondSubUrl}?`;
      if (orgId) url += `org_id=${orgId}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (fromDate) url += `from_date=${fromDate}&`;
      if (toDate) url += `to_date=${toDate}&`;
      if (fileReportType) url += `type=${fileReportType}&`;
      if (sellerId) url += `seller_ids=${sellerId}&`;
      if (departmentId) url += `department_id=${departmentId}&`;
      if (moType) url += `mo_type=${moType}&`;
      if (costingMethod) url += `costing_method=${costingMethod}&`;
      if (status) url += `mo_type=${status}&`;
      if (emails) url += `emails=${emails}&`;
      if (customerId) url += `customer_ids=${customerId}&`;
      if (noWait) url += `no_wait=${noWait}&`;
      if (category) url += `product_category_ids=${category}&`;
    } else {
      if (firstSubUrl) url += `${firstSubUrl}?`;
      if (orgId) url += `org_id=${orgId}&`;
      if (tenantIds) url += `tenant_ids=${tenantIds}&`;
      if (fromDate) url += `from_date=${fromDate}&`;
      if (toDate) url += `to_date=${toDate}&`;
      if (fileReportType) url += `type=${fileReportType}&`;
      if (sellerId) url += `seller_ids=${sellerId}&`;
      if (departmentId) url += `department_id=${departmentId}&`;
      if (moType) url += `mo_type=${moType}&`;
      if (status) url += `mo_type=${status}&`;
      if (emails) url += `emails=${emails}&`;
      if (intervals) url += `interval=${intervals}&`;
      if (noOfColumns) url += `steps=${noOfColumns}&`;
      if (selectedMethod) url += `method=${selectedMethod}&`;
      if (costingMethod) url += `costing_method=${costingMethod}&`;
      if (selectedDate) url += `date=${selectedDate}&`;
      if (customerId) url += `customer_ids=${customerId}&`;
      if (noWait) url += `no_wait=${noWait}&`;
      if (category) url += `product_category_ids=${category}&`;
    }

    if (fileReportType === 'send_email') {
      const reports = await Helpers.get({
        url,
      });
      return reports;
    }
    const reports = await Helpers.getFile({
      url,
    });
    return reports;
  }
}
export default new ReportServices();
